import React, { Suspense } from "react";

const routes = {
  "": React.lazy(() => import("pages/index")),
  privacy: React.lazy(() => import("pages/privacy")),
  travel: React.lazy(() => import("pages/travel")),
  volunteer: React.lazy(() => import("pages/volunteer")),
  "code-of-conduct": React.lazy(() => import("pages/codeOfConduct"))
};

const Router = () => {
  const path = window.location.pathname.replace(/(\/+$)|(^\/+)/gm, "");
  if (path in routes) {
    const Component = routes[path];
    return (
      <Suspense fallback={null}>
        <Component />
      </Suspense>
    );
  } else if (path === "livestream") {
    // this is the link for the youtube closing ceremonies livestream
    window.location.href = "https://www.youtube.com/watch?v=uvZEk-xQv70";
    return null;
  } else if (path === "live") {
    window.location.href = "https://live.hackthenorth.com";
    return null;
  } else {
    window.location.href =
      "https://2018.hackthenorth.com" + window.location.pathname;
    return null;
  }
};

export default Router;
